/*
 * @Author: xxhhwzz000 929865929@qq.com
 * @Date: 2022-01-04 17:11:20
 * @LastEditors: xxhhwzz000 929865929@qq.com
 * @LastEditTime: 2022-08-24 15:34:21
 * @FilePath: \wechat_ticketing3.0\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import { Toast } from 'vant';

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    // eslint-disable-next-line eqeqeq
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
const spotId = getQueryVariable('spot_id');
if (spotId) localStorage.setItem('__shareid', spotId);

const protocol = window.location.protocol || 'http';
const spot = window.localStorage.getItem('__shareid');

const service = axios.create({
  // baseURL: `${protocol}//bwg.kedyx.com/spot/mobile`,
  baseURL: `${protocol}//jxxq.kedyx.com/spot/mobile`,
  // baseURL: `${protocol}//mendian.yunxzn.com/spot/mobile`,
  // baseURL: `${protocol}//longchengmaxi.yunxzn.com/spot/mobile`,
  // baseURL: `${protocol}//gansuxigushuiwu.ctroder.com/spot/mobile`,
  // baseURL: `${protocol}//szdwyht.yunxzn.com/spot/mobile`,
  // baseURL: `${protocol}//p2.ws01.cn/spot/mobile`,
  // baseURL: `${protocol}//lxg.yunxzn.com/spot/mobile`,
  // baseURL: `${protocol}//piao.cestpegp.com/spot/mobile`,
  // baseURL: `${protocol}//cq.cvoon.com/spot/mobile`,

  withCredentials: true,
  timeout: 10000,
});

// request interceptor
service.interceptors.request.use(
  request => {
    // eslint-disable-next-line no-unused-vars
    if (spot) {
      // eslint-disable-next-line no-param-reassign
      request.headers.SPOT = spot;
    }
    // eslint-disable-next-line no-param-reassign
    return request;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    const { code, data } = response.data;
    if (code === 200) return data;
    // if (code === 401) window.location.href = data;
    if (code === 400) {
      Toast.fail(response.data.msg);
      return false;
    }
    return false;
  },
  error => Promise.reject(error)
);

export default service;
